import api from '@/api';
import { API_BASE_URL } from '../../index';
import { WorkOrderFinancialReceiptRequest } from './WorkOrderFinancialReceipt.types';

const CONTROLLER_URL = `${API_BASE_URL}/generate`;

export async function getWorkOrderFinancialReceipt(
  params: WorkOrderFinancialReceiptRequest,
) {
  const result = (await api.getReport(
    `${CONTROLLER_URL}/work-order-financial-receipt`,
    params,
  )) as unknown;

  return result as BlobPart;
}
